import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';

@Component({
  selector: 'ui-action-menu',
  standalone: true,
  imports: [ButtonModule, PopoverModule, CommonModule],
  template: `
    <button
      pButton
      icon="pi pi-ellipsis-v"
      class="p-button-text p-button-rounded p-button-sm"
      (click)="op.toggle($event)"
    ></button>
    <p-popover #op>
      <div class="action-menu" (click)="op.hide()">
        <ng-content></ng-content>
      </div>
    </p-popover>
  `,
  styles: [
    `
      .action-menu {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        min-width: 120px;
      }
      ::ng-deep .action-menu .action-btn {
        width: 100%;
        justify-content: flex-start;
        text-align: start;
      }
    `],
})
export class ActionMenuComponent {}
